export function formatPhoneNumber(input:string) {
    return input.replace(/^1?(\d{3})(\d{3})(\d{4})$/,'$1-$2-$3');
}

export function formatDate(input:string) {
    const dateToFormat = new Date(input);
    if (!isNaN(dateToFormat.getTime())) {
        const convertedDate = dateToFormat.getUTCDate();
        // Months use 0 index
        const convertedMonth = dateToFormat.getMonth() + 1;
        return (convertedMonth < 10 ? '0' + convertedMonth : convertedMonth) + '/' + (convertedDate < 10 ? '0' + convertedDate : convertedDate) + '/' + dateToFormat.getFullYear();
    } else {
        return '';
    }
}

export function sanitizeText(input:string|undefined) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = input ? input : '';

    return tempDiv.textContent?  tempDiv.textContent.trim() : '';
}

/**
 * Encodes special characters that can cause issues in API requests
 * Based on fix for PEG-14684: Resolve Special Character Handling on Help and Contact eMail Forms
 * 
 * Handles characters that have special meaning in URLs/HTTP:
 * - % (percent) - must be encoded first to avoid double-encoding
 * - & (ampersand)
 * - + (plus)
 * - # (hash)
 * - = (equals)
 * 
 * Also handles HTML special characters for XSS prevention:
 * - < > " ' /
 */
export function encodeSpecialCharacters(input: string): string {
    if (!input) {
        return input;
    }
    
    let encoded = input;
    
    // URL special characters - encode % first to avoid double-encoding
    encoded = encoded.replace(/%/g, '%25');
    encoded = encoded.replace(/&/g, '%26');
    encoded = encoded.replace(/\+/g, '%2B');
    encoded = encoded.replace(/#/g, '%23');
    encoded = encoded.replace(/\?/g, '%3F');
    encoded = encoded.replace(/=/g, '%3D');
    
    // HTML special characters for XSS prevention
    encoded = encoded.replace(/</g, '&lt;');
    encoded = encoded.replace(/>/g, '&gt;');
    encoded = encoded.replace(/"/g, '&quot;');
    encoded = encoded.replace(/'/g, '&#x27;');
    encoded = encoded.replace(/\//g, '&#x2F;');
    
    return encoded;
}

/**
 * Sanitizes, formats, and encodes form field values
 * Prevents 500 errors from special characters while maintaining security
 */
export function sanitizeAndFormat(key:string, value:string|undefined) {
    let output = sanitizeText(value);

    if (key.match(/phone/i) && output) {
        output = formatPhoneNumber(output);
    }
    if (key.match(/birthdate/i) && output) {
        output = formatDate(output);
    }
    
    // Apply special character encoding to prevent API errors
    output = encodeSpecialCharacters(output);
    
    return output;
}